import React, {useMemo, useState} from 'react'
import HistoryItem from './HistoryItem'
import OrderDetailHistory from './OrderDetailHistory'

interface Props {
  history: any[]
  children?: React.ReactNode
  orderNumber?: number | any
}

const size = 5
export const OrderHistory: React.FC<Props> = ({history, children, orderNumber}) => {
  const [showMore, setShowMore] = useState(false)
  const [count, setCount] = useState<any>()

  useMemo(() => {
    if (showMore && history) {
      const out = history.length
      setCount(out)
    } else if (!showMore) {
      const out = size
      setCount(out)
    }
  }, [history, showMore])

  const handelShow = () => {
    setShowMore(!showMore)
  }

  return (
    <section className='ms-4'>
      {history &&
        history.slice(0, count).map((his: any, index) => {
          const title = orderNumber
            ? `${`${orderNumber} - ${history.length - index}: ${his.title}`}`
            : `${his.title}`
          return (
            <aside>
              <HistoryItem
                {...his}
                title={title}
                isLast={children ? false : history.length - 1 === index}
              >
                <OrderDetailHistory {...his} title={title} />
              </HistoryItem>
            </aside>
          )
        })}
      {showMore && <aside>{children}</aside>}
      {!showMore && history && history.length < size && <aside>{children}</aside>}
      {history && history.length > size && (
        <div className='d-flex justify-content-start'>
          <button
            className='bg-transparent border-0 underline text-gray-600 fw-bolder mt-1'
            onClick={handelShow}
          >
            {showMore ? ' Show Less' : 'View More History'}
          </button>
        </div>
      )}
    </section>
  )
}

export default OrderHistory
